<mat-sidenav-container style="height:100%;">
  <mat-sidenav #sidenav mat-component-id="sidenav" [opened]="true" mode="side">
    <mat-nav-list>
      <a data-qa-id="environments-nav-link-overview" mat-list-item routerLink="overview" routerLinkActive="active">Overview</a>
    </mat-nav-list>

    <mat-nav-list>
      @for (env of environments; track env) {
        <a [attr.data-qa-id]="'environments-nav-link-environment-' + env.Id" mat-list-item [routerLink]="['/environments/edit', env.Id]" routerLinkActive="active"
        >{{env.Name}}</a>
      }
    </mat-nav-list>
  </mat-sidenav>
  <router-outlet></router-outlet>
</mat-sidenav-container>
